// src/App.jsx
import React from 'react';
import FileConversion from './FileConversion';

const App = () => {
  return (
    <div className="App">
    
      <FileConversion />
    </div>
  );
}

export default App;
